import { render, staticRenderFns } from "./screenshot.svg.vue?vue&type=template&id=bc3ca842&scoped=true"
import script from "./screenshot.svg.vue?vue&type=script&lang=ts"
export * from "./screenshot.svg.vue?vue&type=script&lang=ts"
import style0 from "./screenshot.svg.vue?vue&type=style&index=0&id=bc3ca842&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3ca842",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc3ca842')) {
      api.createRecord('bc3ca842', component.options)
    } else {
      api.reload('bc3ca842', component.options)
    }
    module.hot.accept("./screenshot.svg.vue?vue&type=template&id=bc3ca842&scoped=true", function () {
      api.rerender('bc3ca842', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/screenshot.svg.vue"
export default component.exports